import { render, staticRenderFns } from "./DataRely.vue?vue&type=template&id=2111e29b&scoped=true&"
import script from "./DataRely.vue?vue&type=script&lang=js&"
export * from "./DataRely.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2111e29b",
  null
  
)

export default component.exports